import { render, staticRenderFns } from "./PromotionStepGeneralInfo.vue?vue&type=template&id=42c2a0fe&scoped=true&"
import script from "./PromotionStepGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./PromotionStepGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./PromotionStepGeneralInfo.vue?vue&type=style&index=0&id=42c2a0fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c2a0fe",
  null
  
)

export default component.exports